// the first y-axis is the default chart y-axis
export const hasCustomYAxis = (option) => option.yAxisIndex && option.yAxisIndex > 0;
export const handlesYAxis = (type) => ['series.line', 'series.scatter'].includes(type);
